export const load = () => ({
	h1: 'Comfort, Soundproofing, & Energy Efficiency Solutions',
	title:
		'Find Solutions for Window Comfort, Soundproofing, and Energy Efficiency',
	description:
		'Window inserts are the best solution for insulating windows, soundproofing, and privacy, at a significantly lower cost than replacements windows.',
	showTitle: true,
});
